import $ from 'jquery';

$(document).ready(function() {
    $('.js-slide-materials').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4.6,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
        {
            breakpoint: 1620,
            settings: {
                slidesToShow: 4.1,
                slidesToScroll: 1,
                arrows: true,
                dots: false
           }
        },
        {
            breakpoint: 1150,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                dots: false
           }
        },
        {
            breakpoint: 1100,
            settings: {
                slidesToShow: 2.4,
                slidesToScroll: 1,
                arrows: true,
                dots: false
           }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1.1,
                slidesToScroll: 1,
                arrows: true,
                dots: false
           }
        },
        {
            breakpoint: 520,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false
           }
        }
        ]
    });
    $(window).on('resize', function() {
        $('.js-slide-materials').slick('resize');
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/index/slide-materials.js